import type { FaireProductEntity } from "../../entity_types/product";

export const p_xpfjquabqb: FaireProductEntity = {
  token: "p_xpfjquabqb",
  type: "product",
  name: "Sweet Maui Onion Kettle Cooked Potato Chips",
  brandToken: "b_7czabpidt2",
  brandName: "Deep River Snacks",
  imageUrl: "https://cdn.faire.com/fastly/be8506072b5fd6881b0f884f05da0cdf9014cc4f7370e567a8abf3b507c327d2.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/675eadf59e0ea9b259ff9a05a55a527ab666a763672dd88eeb32bbcf17d1f28b.webp",
    "https://cdn.faire.com/fastly/d9ea0796b10aec14187a109efc7cdad73e3753fa3e1aef4f7089c3c1191ff496.webp"
  ],
  priceDollars: 41.56,
  description: "Combine the flavors of sweet onions and garlic, add our thick-cut potato chips, and you've got one of our most popular kettle chip varieties. It’s simply addictive. Just don’t say that we didn’t warn you.",
  tags: [],
  msrpDollars: 83.11,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:55.792Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
